/* Mouse-drag for the collection film strip.
   A tile is a link, so a desktop drag would otherwise pull the link
   instead of moving the row. Touch keeps the browser's own scroll. */
(function () {
  if (window.__belnayCollectionDrag) return;
  window.__belnayCollectionDrag = true;

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function padLeft(rail) {
    return parseFloat(window.getComputedStyle(rail).paddingLeft) || 0;
  }

  function positionsFor(rail) {
    var pad = padLeft(rail);
    var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    return Array.prototype.map.call(rail.children, function (item) {
      if (item.nodeType !== 1) return 0;
      var desired = item.offsetLeft - pad;
      if (desired < 0) desired = 0;
      if (desired > maxScroll) desired = maxScroll;
      return desired;
    });
  }

  function nearestIndex(positions, scrollLeft, preferLater) {
    var index = 0;
    var best = Infinity;
    for (var i = 0; i < positions.length; i++) {
      var distance = Math.abs(positions[i] - scrollLeft);
      if (distance < best - 0.5) {
        best = distance;
        index = i;
      } else if (Math.abs(distance - best) <= 0.5 && preferLater) {
        index = i;
      }
    }
    return index;
  }

  function bind(rail) {
    if (rail.dataset.dragBound === "true") return;
    rail.dataset.dragBound = "true";

    var active = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var startIndex = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var distance = 0;

    function onMove(event) {
      if (!active || event.pointerType !== "mouse") return;
      var dx = event.clientX - startX;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) {
        moved = true;
        rail.classList.add("is-dragging");
      }
      var now = performance.now();
      var step = lastX - event.clientX;
      velocity = (step / (now - lastTime || 16)) * 1000;
      distance += Math.abs(step);
      lastX = event.clientX;
      lastTime = now;
      rail.scrollLeft = startScroll - dx;
    }

    function onUp() {
      if (!active) return;
      active = false;
      document.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerup", onUp);
      document.removeEventListener("pointercancel", onUp);
      rail.classList.remove("is-dragging");
      if (!moved) return;

      rail.addEventListener(
        "click",
        function (event) {
          event.preventDefault();
          event.stopPropagation();
        },
        { capture: true, once: true }
      );

      var positions = positionsFor(rail);
      if (!positions.length) return;
      var index = nearestIndex(positions, rail.scrollLeft, rail.scrollLeft > startScroll);
      if (index === startIndex && Math.abs(velocity) > 450 && distance > 24) {
        index += velocity > 0 ? 1 : -1;
      }
      if (index < 0) index = 0;
      if (index > positions.length - 1) index = positions.length - 1;
      rail.scrollTo({
        left: positions[index],
        behavior: reduced ? "auto" : "smooth",
      });
    }

    rail.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "mouse" || event.button !== 0) return;
      if (event.target.closest("button, input, textarea, select, label")) return;
      active = true;
      moved = false;
      startX = lastX = event.clientX;
      startScroll = rail.scrollLeft;
      lastTime = performance.now();
      velocity = 0;
      distance = 0;
      startIndex = nearestIndex(positionsFor(rail), startScroll, false);
      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
      document.addEventListener("pointercancel", onUp);
    });

    rail.addEventListener("dragstart", function (event) {
      event.preventDefault();
    });

    var frame = rail.parentElement;
    if (!frame) return;
    var prev = frame.querySelector("[data-drag-prev]");
    var next = frame.querySelector("[data-drag-next]");

    function step(direction) {
      var positions = positionsFor(rail);
      var current = rail.scrollLeft;
      var target = current;
      var i;
      if (direction > 0) {
        for (i = 0; i < positions.length; i++) {
          if (positions[i] > current + 12) {
            target = positions[i];
            break;
          }
        }
      } else {
        for (i = positions.length - 1; i >= 0; i--) {
          if (positions[i] < current - 12) {
            target = positions[i];
            break;
          }
        }
      }
      rail.scrollTo({ left: target, behavior: reduced ? "auto" : "smooth" });
    }

    function syncArrows() {
      var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      if (prev) prev.hidden = rail.scrollLeft <= 8;
      if (next) next.hidden = maxScroll <= 8 || rail.scrollLeft >= maxScroll - 8;
    }

    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
    rail.addEventListener("scroll", syncArrows, { passive: true });
    window.addEventListener("resize", syncArrows);
    syncArrows();
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-drag-rail]").forEach(bind);
  }

  init(document);
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
